import { Icon, SmallText } from '@epilot/base-elements'
import { ReactChild, ReactChildren } from 'react'
import styled from 'styled-components'

import useEcpTranslation from '../../hooks/common/useEcpTranslation'

type AlertStatus = 'info' | 'error'

interface Props {
  children?: ReactChildren | ReactChild
  message?: string
  status?: AlertStatus
}

const AlertMessage = ({
  children,
  message,
  status = 'info',
  ...rest
}: Props) => {
  const { t } = useEcpTranslation()

  return (
    <ValidationMessage $status={status} data-testid="error-msg" {...rest}>
      <Icon
        color={status === 'info' ? 'primary' : 'error'}
        name="info"
        style={{ lineHeight: 'initial' }}
        translate="no"
      />

      <MessageContainer component="div">
        {t(message)}
        {children}
      </MessageContainer>
    </ValidationMessage>
  )
}

export default AlertMessage

const ValidationMessage = styled.div<{ $status: AlertStatus }>`
  margin-bottom: 1.6rem;
  padding: 0.6rem;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  display: flex;
  color: ${({ theme }) => theme.palette.grey[800]};
  align-items: center;
  background-color: ${({ theme, $status }) =>
    $status === 'info' ? theme.palette.primary[100] : theme.palette.error[50]};

  & > .material-icons {
    line-height: 25px;
  }
`

const MessageContainer = styled(SmallText)`
  padding-left: 0.5rem;
`
